import { fadeIn, fadeOut, fadeTo, SLOW } from '../utils/animate';
import { onScrollEnd } from '../utils/debounce';
import { ready } from '../utils/ready';

// Families list and family pages with the date calendar (templates/calendar.php,
// which defines window.Families = {all, cururl, home, date}).
//
// - Family panels fade in at random speeds.
// - The family's date is highlighted in the calendar.
// - Clicking a date (.hasstory) loads that date's families (admin-ajax
//   `families_by_date`) into #families-container. That is one history entry;
//   while scrolling, the address bar follows the first family in view
//   (replaceState). Back/Forward reload the page, because the loaded content
//   doesn't match the other entries.

const inViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
};

function showFamilyInViewInUrl() {
    if (!window.history.state?.familiesDate) return;
    const first = [...document.querySelectorAll('#families-container .family-container')].find(inViewport);
    const url = first?.dataset.permalink;
    if (url && url !== window.location.href) {
        window.history.replaceState(window.history.state, '', url);
    }
}

// Calendar dates are data-date="Ymd"; Families.date is "Y-m-d".
const highlightDate = (date) => {
    const ymd = String(date).replaceAll('-', '');
    document.querySelectorAll('[data-date]').forEach((el) => el.classList.toggle('thisdate', el.dataset.date === ymd));
};

export default function families() {
    const {Families} = window;
    const container = document.getElementById('families-container');
    if (!Families || !container) return;

    document.querySelectorAll('.family-panel').forEach((panel) => {
        fadeTo(panel, [100, 200, 300, 400][Math.floor(Math.random() * 4)], 1);
    });

    if (Families.date) {
        highlightDate(Families.date);
    }

    // Small screens: the calendar opens from a button.
    document.getElementById('datepicker')?.addEventListener('click', () => {
        document.querySelectorAll('.calendars').forEach((c) => c.classList.add('expand'));
    });

    let urlFollowsScroll = false;

    document.querySelectorAll('.hasstory').forEach((link) => link.addEventListener('click', async (e) => {
        e.preventDefault();
        document.querySelectorAll('.calendars').forEach((c) => c.classList.remove('expand'));
        const date = link.dataset.date;

        const response = await fetch(window.adminajax, {
            method: 'POST',
            body: new URLSearchParams({action: 'families_by_date', datestring: date}),
            credentials: 'same-origin',
        });
        if (!response.ok) return;
        const html = await response.text();

        highlightDate(date);
        await fadeOut(container, SLOW);
        window.scrollTo(0, 0);
        container.innerHTML = html;
        fadeIn(container, SLOW);

        const first = container.querySelector('.family-container')?.dataset.permalink;
        if (first) {
            window.history.pushState({familiesDate: date}, '', first);
        }
        if (!urlFollowsScroll) {
            urlFollowsScroll = true;
            onScrollEnd(showFamilyInViewInUrl);
            window.addEventListener('popstate', () => window.location.reload());
        }
    }));
}

ready(families);
